/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    unitBase,
    rowSpacing,
    fontSize,
    fontSizeDesktop,
    enterpriseCSS,
} from './variables';

export const main = (typography, palette) => ({
    '@keyframes checkmark-stroke': {
        '0%': { 'stroke-dashoffset': '400', opacity: 1 },
        '100%': { 'stroke-dashoffset': 0, opacity: 1 },
    },
    '@keyframes rotating': {
        from: {
            transform: 'rotate(0deg)',
        },
        to: {
            transform: 'rotate(360deg)',
        },
    },
    main: {
        fontFamily: typography.fontFamily,
        fontWeight: 'normal',
        'font-size': fontSize.body,
        '@media screen and (min-width: 600px)': {
            margin: `${rowSpacing * 2}px 0 ${rowSpacing}px ${rowSpacing}px`,
            width: `calc(100vw - ${rowSpacing * 2}px)`,
        },
        // 'line-height': `${rowSpacing * 2}px`,
        'line-height': '1.4em',
        '& *': {
            outline: 'none',
            fontFamily: typography.fontFamily,
        },
        '& h1, & .h1': {
            'font-size': `${fontSize.h1}px`,
            'font-weight': 'normal',
            color: enterpriseCSS.palette.body,
            marginBottom: `${rowSpacing}px`,
            display: 'block',
        },
        '& h2, & .h2': {
            'font-weight': 'bold',
            fontSize: `${fontSize.h2}px`,
            color: enterpriseCSS.palette.body,
            marginBottom: `${rowSpacing}px`,
            textTransform: 'uppercase',
            display: 'block',
        },
        '& .h2Divider': {
            'font-weight': 'bold',
            color: enterpriseCSS.palette.base.h2Divider.color,
            backgroundColor: enterpriseCSS.palette.base.h2Divider.backgroundColor,
            fontSize: `${fontSize.h2}px`,
            textTransform: 'uppercase',
            display: 'block',
            padding: rowSpacing,
            margin: `${rowSpacing}px -${rowSpacing}px`,
        },
        '& h3, & .h3': {
            'font-size': `${fontSize.body}px`,
            'font-weight': 'bold',
            color: enterpriseCSS.palette.body,
            marginBottom: `${rowSpacing}px`,
            display: 'block',
        },
        '& p': {
            marginTop: 0,
            marginBottom: rowSpacing,
        },
        '& .opacity1': { opacity: '1 !important' },
        '& .opacity0': { opacity: '0 !important' },
        '& .white-color': { color: `${palette.common?.white || '#fff'} !important` },
        '& .error-color': {
            color: `${enterpriseCSS.palette.error} !important`,
        },
        '& .body-color': {
            color: `${enterpriseCSS.palette.body} !important`,
        },
        '& .black-color': {
            color: `${enterpriseCSS.palette.black} !important`,
        },
        '& .blue-color': {
            color: `${enterpriseCSS.palette.blue} !important`,
        },
        '& .gray-color': {
            color: `${enterpriseCSS.palette.gray1} !important`,
        },
        '& .gray-bg': {
            backgroundColor: `${enterpriseCSS.palette.gray3} !important`,
        },
        '& .primary-color': {
            color: `${palette.primaryButton} !important`,
        },
        '& .red-color': { color: `${enterpriseCSS.palette.red} !important` },
        '& .green-color': { color: `${palette.green} !important` },
        '& .success-color': {
            color: `${enterpriseCSS.palette.success} !important`,
            '& path': { stroke: enterpriseCSS.palette.success },
        },
        '& .large': { 'font-size': `${fontSize.large}px !important` },
        '& .small': { 'font-size': `${fontSize.small}px !important` },
        '& .link': {
            'font-size': fontSize.body,
            // color: palette.cta1,
            color: enterpriseCSS.palette.blue,
            border: '0',
            padding: '0',
            background: 'transparent',
            cursor: 'pointer',
            'text-decoration': 'underline',
            'text-transform': 'initial',
            '&.as-button': {
                'text-decoration': 'none',
                fontWeight: 'bold',
                cursor: 'pointer',
            },
            '&.no-underline': {
                'text-decoration': 'none',
            },
            '&.has-icon-right': {
                position: 'relative',
                paddingRight: `${rowSpacing * 2}px`,
                '& > svg': {
                    position: 'absolute',
                    right: 0,
                    top: '-6px',
                },
            },
        },
        '& .row': {
            margin: `0 ${rowSpacing}px ${rowSpacing * 2}px ${rowSpacing}px`,
        },
        '& .border-bottom': {
            borderBottom: `1px solid ${palette.grey7}`,
        },
        '& .line-clamp-2': {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            '-webkit-box-orient': 'vertical',
            display: '-webkit-box',
            '-webkit-line-clamp': 2,
            height: 'calc(2em + 10px)',
            maxWidth: '170px',
        },
        '& .display-flex': {
            display: 'flex',
            alignItems: 'center',
            '&.column': {
                flexDirection: 'column',
            },
        },
        '& .whitespace-nowrap': { whiteSpace: 'nowrap !important' },
        '& .flex-1': { flex: '1 !important' },
        '& .flex-2': { flex: '2 !important' },
        '& .flex-none': { flex: 'none !important' },
        '& .display-none': { display: 'none !important' },
        '& .full-width': { width: '100%' },
        '& .padding': { padding: rowSpacing },
        '& .no-padding': { padding: '0 !important' },
        '& .no-margin': { margin: '0 !important' },
        '& .margin-left-negative': {
            marginLeft: `${rowSpacing * -1}px`,
        },
        '& .margin-top': { marginTop: `${rowSpacing}px !important` },
        '& .margin-top-half': { marginTop: `${rowSpacing / 2}px` },
        '& .margin-bottom-half': { marginBottom: `${rowSpacing / 2}px` },
        '& .margin-top-2x': {
            marginTop: `${rowSpacing * 2}px !important`,
            '&.no-margin': { marginTop: '0 !important' },
        },
        '& .no-margin-top': { marginTop: '0 !important' },
        '& .margin-bottom': { marginBottom: rowSpacing },
        '& .margin-bottom-left-icon': {
            marginBottom: `${rowSpacing - 4}px !important`,
        },
        '& .margin-bottom-2x': {
            marginBottom: `${rowSpacing * 2}px !important`,
        },
        '& .margin-left-8x': {
            marginLeft: `${rowSpacing - 4}px !important`,
        },
        '& .margin-bottom-4x': {
            marginBottom: `${rowSpacing * 4}px !important`,
        },
        '& .padding-top': {
            paddingTop: `${rowSpacing}px !important`,
        },
        '& .padding-left': {
            paddingLeft: `${rowSpacing}px !important`,
        },
        '& .padding-right': {
            paddingRight: `${rowSpacing}px !important`,
        },
        '& .padding-left-2x': {
            paddingLeft: `${rowSpacing * 2}px !important`,
        },
        '& .padding-right-2x': {
            paddingRight: `${rowSpacing * 2}px !important`,
        },
        '& .padding-bottom': {
            paddingBottom: `${rowSpacing}px !important`,
        },
        '& .padding-top-2x': {
            paddingTop: `${rowSpacing * 2}px !important`,
        },
        '& .padding-bottom-2x': {
            paddingBottom: `${rowSpacing * 2}px !important`,
        },
        '& .padding-bottom-4x': {
            paddingBottom: `${rowSpacing * 4}px !important`,
        },
        '& .no-margin-bottom': { marginBottom: '0 !important' },
        '& .no-padding-bottom': { paddingBottom: '0 !important' },
        '& .no-padding-right': { paddingRight: '0 !important' },
        '& .no-padding-left': { paddingLeft: '0 !important' },
        '& .no-margin-right': { marginRight: '0 !important' },
        '& .margin-right': { marginRight: `${rowSpacing}px !important` },
        '& .margin-right-2x': { marginRight: `${rowSpacing * 2}px !important` },
        '& .margin-right-icon': { marginRight: `${unitBase * 2}px` },
        '& .margin-left': { marginLeft: rowSpacing },
        '& .margin-right-half': {
            marginRight: `${rowSpacing / 2}px !important`,
        },
        '& .spacing-right': {
            paddingRight: `${unitBase}px !important`,
        },
        '& .position-relative': { position: 'relative' },
        '& .position-absolute-bottom': {
            position: 'absolute',
            bottom: 0,
            width: '100%',
        },
        '& .hide-view-details': {
            display: 'none',
        },
        '& .min-height-15x': { minHeight: rowSpacing * 15 },
        '& .no-wrap': { 'white-space': 'nowrap' },
        '& .display-block': { display: 'block' },
        '& .display-inline-block': { display: 'inline-block !important' },
        '& .align-vertical-middle': { verticalAlign: 'middle !important' },
        '& .align-left': { textAlign: 'left' },
        '& .align-center': { textAlign: 'center' },
        '& .align-right': { textAlign: 'right' },
        '& .float-left': { float: 'left !important' },
        '& .float-right': { float: 'right !important' },
        '& .normal': { 'font-weight': 'normal !important' },
        '& .bold': { 'font-weight': '700 !important' },
        '& .uppercase': { textTransform: 'uppercase' },
        '& .no-uppercase': { textTransform: 'initial' },
        '& .lowercase': { textTransform: 'lowercase' },
        '& .white': { color: `${palette.common?.white || '#fff'} !important` },
        '& .gray-text': { color: `${enterpriseCSS.palette.gray1} !important` },
        '& .card-border-3': {
            border: `3px solid ${enterpriseCSS.palette.gray3}`,
        },
        '& .split': {
            display: 'flex',
            'align-items': 'start',
            '&.row-reverse': { 'flex-direction': 'row-reverse' },
            '&.align-center': { 'align-items': 'center' },
            '&.align-bottom': { 'align-items': 'flex-end' },
            '& > *': {
                flex: '1',
                display: 'inline-block',
                marginRight: rowSpacing * 2,
                '&:last-child': { marginRight: 0 },
                '&.flex-half': {
                    flex: '0.5',
                },
                '&.flex-none': {
                    flex: 'none',
                },
            },
        },
        '& .success-inline': {
            color: palette.common?.white || '#fff',
            backgroundColor: enterpriseCSS.palette.success,
            display: 'block',
            padding: rowSpacing,
            marginBottom: rowSpacing,
            borderRadius: unitBase,
        },
        '& .error-inline': {
            color: palette.common?.white || '#fff',
            backgroundColor: enterpriseCSS.palette.error,
            display: 'block',
            padding: rowSpacing,
            marginBottom: rowSpacing,
            borderRadius: unitBase,
        },
        '& .non-auth-title': {
            fontWeight: '800',
            fontSize: '15px !important',
            marginRight: '7px',
        },
        '& .margin-bottom-4px': {
            marginBottom: '4px',
        },
        '& .non-auth-screen': {
            display: 'inline-flex',
        },
        '& .non-auth-user': {
            width: '84%',
            border: '2px solid #e3e3e3',
            padding: '10px',
            paddingBottom: '3px',
            margin: '0 auto',
            borderRadius: '4px',
        },
        '& .breakpoint-width': {
            width: '100% !important',
        },
        '& .crossed-price': {
            color: palette.grey10,
            'text-decoration': 'line-through',
            marginRight: '8px',
        },
        '& .discount-price': { color: palette.pink1 },
        '& .divider': {
            width: '100%',
            textAlign: 'center',
            color: palette.grey2,
            'font-style': 'italic',
            display: 'flex',
            margin: `${rowSpacing * 2}px 0`,

            '& span:first-of-type, & span:last-of-type': {
                flex: '1',
                'border-bottom': `1px solid ${palette.grey2}`,
                'max-height': '10px',
            },
            '& span:not(:first-of-type):not(:last-of-type)': {
                padding: `0 ${rowSpacing}px`,
                'font-size': '12px',
            },
        },
        '& .spinner': {
            position: 'absolute',
            top: '60%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            '&.top-inherit': {
                top: 'inherit',
            },
            '&.gift-list': {
                top: '70%',
            },
            '& > svg': {
                width: `${unitBase * 15}px`,
                height: `${unitBase * 15}px`,
            },
        },
        '& .rotating': {
            animation: 'rotating 2s linear infinite',
        },
        '& .icon-x-small': { width: `${unitBase * 2}px` },
        '& [type="search"]::-webkit-search-cancel-button': {
            '-webkit-appearance': 'none',
            height: `${rowSpacing * 2}px`,
            width: `${rowSpacing * 2}px`,
            background:
                'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPgo8cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptNSAxMWgtNHY0aC0ydi00SDd2LTJoNFY3aDJ2NGg0djJ6IiBmaWxsPSIjOTA5MDkwIi8+Cjwvc3ZnPg==)',
            backgroundSize: '65%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            transform: 'rotate(45deg)',
        },
        // Button
        '& button': {
            '&.buttonHD': {
                color: palette.common?.white || '#fff',
                backgroundColor: palette.primaryButton,
                fontFamily: typography.fontFamily,
                boxSizing: 'border-box',
                WebkitFontSmoothing: 'antialiased',
                fontWeight: '700',
                width: '100%',
                fontSize: '1em',
                textTransform: 'uppercase',
                borderRadius: '20px',
                padding: `6px ${rowSpacing + 4}px`,
                // lineHeight: '1.46em',
                '&[disabled]': {
                    backgroundColor: palette.disableButton,
                },
            },
            '&.buttonHDSecondary': {
                color: palette.common?.white || '#fff',
                backgroundColor: enterpriseCSS.palette.button.darkGray,
                fontFamily: typography.fontFamily,
                boxSizing: 'border-box',
                WebkitFontSmoothing: 'antialiased',
                fontWeight: '700',
                fontSize: '1em',
                textTransform: 'none',
                padding: `6px ${rowSpacing + 4}px`,
                '&[disabled]': {
                    backgroundColor: palette.disableButton,
                },
            },
            '&.buttonHDSecondaryRound': {
                color: palette.common?.white || '#fff',
                backgroundColor: enterpriseCSS.palette.button.darkGray,
                fontFamily: typography.fontFamily,
                borderRadius: '20px',
                boxSizing: 'border-box',
                WebkitFontSmoothing: 'antialiased',
                fontWeight: '700',
                fontSize: '1em',
                textTransform: 'uppercase',
                padding: `6px ${rowSpacing + 4}px`,
                '&[disabled]': {
                    backgroundColor: palette.disableButton,
                },
                '&.get-code-btn': {
                    float: 'none',
                    marginRight: 0,
                },
                '&.sign-in-btn': {
                    float: 'none',
                    marginRight: 0,
                },
                '&.create-account-btn': {
                    float: 'none',
                    marginRight: 0,
                },
            },
            '&.buttonHDSquare': {
                color: palette.common?.white || '#fff',
                backgroundColor: palette.primaryButton,
                fontFamily: typography.fontFamily,
                boxSizing: 'border-box',
                WebkitFontSmoothing: 'antialiased',
                fontWeight: '700',
                fontSize: '1em',
                textTransform: 'uppercase',
                padding: `6px ${rowSpacing + 4}px`,
                border: `1px solid ${palette.primaryButton} !important`,
                '&:hover': {
                    backgroundColor: palette.primaryButton,
                },
                '&[disabled]': {
                    backgroundColor: palette.disableButton,
                    border: `1px solid ${palette.disableButton} !important`,
                },
            },
            '&.buttonHDWhite': {
                color: palette.secondaryButton,
                backgroundColor: palette.common?.white || '#fff',
                fontFamily: typography.fontFamily,
                boxSizing: 'border-box',
                WebkitFontSmoothing: 'antialiased',
                fontWeight: '700',
                fontSize: '1em',
                textTransform: 'uppercase',
                padding: `6px ${rowSpacing + 4}px`,
                '&[disabled]': {
                    backgroundColor: palette.disableButton,
                },
            },
            '&.buttonBlue, &.buttonGray': {
                color: palette.common?.white || '#fff',
                backgroundColor: enterpriseCSS.palette.blue,
                fontFamily: typography.fontFamily,
                boxSizing: 'border-box',
                WebkitFontSmoothing: 'antialiased',
                fontWeight: 'bold',
                fontSize: '1em',
                textTransform: 'capitalize',
                borderRadius: '20px',
                flex: 'none',
                boxShadow: 'none',
                // border: `1px solid ${enterpriseCSS.palette.green}`,
                border: 'none',
                minWidth: '160px',
                padding: `${unitBase}px ${unitBase}px`,
                '&[disabled]': {
                    backgroundColor: palette.disableButton,
                },
            },
            '&.buttonOutline': {
                backgroundColor: palette.common?.white || '#fff',
                color: enterpriseCSS.palette.blue,
                border: `1px solid ${enterpriseCSS.palette.blue}`,
                boxShadow: 'none',
                fontSize: '1em',
                '&:hover': {
                    backgroundColor: palette.common?.white || '#fff',
                    color: enterpriseCSS.palette.blue,
                },
            },
            '&.buttonGray': {
                backgroundColor: enterpriseCSS.palette.gray1,
            },
            '&.buttonDisabled': {
                backgroundColor: palette.disableButton,
            },
            '&.adornment-button': {
                fontSize: fontSize.small,
                padding: '4px',
            },
            '&.narrow-button': {
                paddingLeft: '8px',
                paddingRight: '8px',
                width: 'calc(100% - 16px)',
            },
            '&.small-text': { 'font-size': '0.9em' },
            '&.back-arrow-button': {
                minWidth: '30px',
                padding: '6px 6px 6px 0',
            },
            '&.min-width-100': { minWidth: '100px !important' },
        },
        // Carousel
        '& .carousel-container': {
            width: '100%',
            position: 'relative',
            display: 'inline-flex !important', // IE 11
            margin: '0',
            '& .slick-list': {
                margin: '0',
                padding: '0',
                touchAction: 'none',
                'touch-action': 'pan-y',
                width: '100%',
                '& .slick-track': {
                    position: 'relative',
                    top: '0',
                    left: '0',
                    display: 'flex',
                    flexDirection: 'row',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    float: 'left',
                    '& .slick-slide': {
                        minHeight: '1px',
                        marginRight: rowSpacing,
                    },
                },
            },
        },
        // Select material UI
        '& .select-wrapper': {
            display: 'block',
            '& .select-class': {
                fontSize: `${fontSize.component}px`,
                fontWeight: 'normal',
            },
            '& .select-root': {
                fontSize: `${fontSize.component}px`,
                boxSizing: 'border-box',
            },
            '& .select-icon': { color: '#000' },
        },
        '& .checkmark': {
            fill: 'none',
            stroke: '#000',
            'stroke-linecap': 'round',
            'stroke-miterlimit': '10',
            'stroke-width': '12px',
            'stroke-dasharray': '400',
            '&.animated': {
                animation: 'checkmark-stroke 1s forwards',
                'animation-timing-function': 'ease-in',
                'animation-delay': '.5s',
                'stroke-linejoin': 'round',
                // opacity: 0, // TODO
                opacity: 1,
            },
        },
        '& .list-item-text span:first-child': {
            fontSize: '1rem',
        },
        '& .checkbox-selecter': {
            padding: unitBase * 2,
            '&.checkboxHD': {
                color: '#000000',
            },
        },
        // /////////////////////// //
        // Desktop CSS Starts Here //
        // /////////////////////// //
        '&.desktop, & .desktop': {
            maxWidth: 1400,
            margin: `${rowSpacing * 2}px auto`,
            marginTop: '48px', // rowSpacing * 4

            '& .container': {
                width: `calc(100% - ${rowSpacing * 2}px)`,
                // margin: 'auto',
            },
            '& *:not(h1):not(h2):not(svg):not(legend)': {
                fontSize: fontSizeDesktop.body,
            },
            '& h1, & .h1': {
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: `${fontSizeDesktop.h1}px`,
                color: `${enterpriseCSS.palette.black}`,
            },
            '& h2, &.h2': {
                color: enterpriseCSS.palette.gray1,
                fontSize: '16px',
                fontWeight: 700,
                paddingTop: 0,
                whiteSpace: 'nowrap',
                textTransform: 'uppercase',
                marginTop: '0 !important',
            },
            '& .divider': {
                maxWidth: 400,
                margin: `${rowSpacing * 2}px auto`,
            },
            '& .title': {
                fontSize: `${fontSizeDesktop.title}px !important`,
            },
            '& .checkbox': {
                color: enterpriseCSS.palette.checkbox,
            },
            '&.HD, &.CCO': {
                '& .checkbox': {
                    color: `${palette.cms?.checkbox || '#4A90E2'} !important`,
                },
                '& button': {
                    fontFamily: typography.fontFamily,
                    boxSizing: 'border-box',
                    WebkitFontSmoothing: 'antialiased',
                    fontWeight: '700',
                    width: 'auto',
                    minWidth: 150,
                    fontSize: '1em',
                    // textTransform: 'none',
                    borderRadius: '20px',
                    padding: '6px 30px',
                    boxShadow: 'none',
                    // primary button
                    color: palette.common?.white || '#fff',
                    backgroundColor: palette.cms?.primary || '#a1001a',
                    border: `1px solid ${palette.cms?.primary || '#a1001a'}`,
                    '&:hover': {
                        color: palette.common?.white || '#fff',
                        border: `1px solid ${palette.cms?.primary_hover || '#d73833'}`,
                        backgroundColor: palette.cms?.primary_hover || '#d73833',
                    },
                    '&[disabled]': {
                        color: palette.grey8,
                        border: `1px solid ${palette.grey['300']}`,
                        backgroundColor: palette.grey['300'],
                    },
                    '&.small': {
                        padding: '2px !important',
                        minWidth: 'auto',
                        '& span': {
                            fontSize: '1em !important',
                        },
                    },
                    // secondary button
                    '&.secondary': {
                        color: palette.cms?.secondary || '#161616',
                        backgroundColor: palette.common?.white || '#fff',
                        border: `1px solid ${palette.cms?.white || '#161616'}`,
                        '&:hover': {
                            color: palette.common?.white || '#fff',
                            border: `1px solid ${palette.cms?.secondary || '#161616'}`,
                            backgroundColor: palette.cms?.secondary || '#161616',
                        },
                        '&[disabled]': {
                            color: palette.grey8,
                            border: `1px solid ${palette.grey['300']}`,
                            backgroundColor: palette.grey['300'],
                        },
                    },
                    // tertiary button
                    '&.tertiary': {
                        color: palette.common?.white || '#fff',
                        backgroundColor: palette.cms?.tertiary_font_color || '#161616', // TODO
                        border: `1px solid ${palette.cms?.tertiary_font_color || '#161616'}`, // TODO
                        '&:hover': {
                            color: palette.common?.white || '#fff',
                            border: `1px solid ${palette.cms?.tertiary_hover || '#6f6f6f'}`,
                            backgroundColor: palette.cms?.tertiary_hover || '#6f6f6f',
                        },
                        '&[disabled]': {
                            color: palette.grey8,
                            border: `1px solid ${palette.grey['300']}`,
                            backgroundColor: palette.grey['300'],
                        },
                    },
                },
            },
            '&.CCO': {
                '& button': {
                    borderRadius: '2px !important',
                    padding: '6px 10px !important',
                },
            },
            '& button': {
                width: 'auto',
                minWidth: '150px',
                float: 'right',
                color: palette.common?.white || '#fff',
                marginRight: rowSpacing * 2,
                backgroundColor: enterpriseCSS.palette.darkRed || '#a1001a', // TODO
                border: `1px solid ${enterpriseCSS.palette.darkRed}` || '#a1001a', // TODO
                borderRadius: 2,
                padding: '6px 12px',
                boxShadow: 'none',
                fontWeight: '700',
                '&[disabled]': {
                    border: `1px solid ${palette.disableButton}`,
                    backgroundColor: palette.disableButton,
                },
                '&:hover': {
                    color: palette.common?.white || '#fff',
                    backgroundColor: enterpriseCSS.palette.hoverRed, // TODO
                },
                '&.small': {
                    width: '80px !important', // TODO
                },
                '&.float-none': {
                    float: 'none',
                },
                '&.width-auto': {
                    width: 'auto',
                },
                '&.red': {
                    border: `1px solid ${palette.snipeTextPromo}`, // TODO
                    backgroundColor: palette.snipeTextPromo, // TODO
                    '&:hover': {
                        backgroundColor: palette.snipeTextPromo, // TODO
                    },
                },
                '&.outline': {
                    backgroundColor: palette.common?.white || '#fff',
                    color: enterpriseCSS.palette.blue, // TODO
                    border: `1px solid ${enterpriseCSS.palette.blue}`, // TODO
                    '&:hover': {
                        backgroundColor: palette.common?.white || '#fff',
                        color: enterpriseCSS.palette.blue, // TODO
                    },
                },
                '&.buttonGray': {
                    borderRadius: 0,
                },
                '&.link': {
                    color: `${enterpriseCSS.palette.blue} !important`, // TODO
                    backgroundColor: 'transparent !important',
                    textDecoration: 'none',
                    background: 'none !important',
                    border: 'none !important',
                    boxShadow: 'none',
                    fontWeight: '500 !important',
                    float: 'none',
                    padding: '0 !important',
                    margin: '0 !important',
                    '&.underline': {
                        textDecoration: 'underline',
                    },
                },
                '&.back-link': {
                    width: 'auto',
                    margin: 0,
                },
                '&.adornment-button': {
                    padding: '4px !important',
                    border: '0 !important',
                    background: 'none !important',
                    color: `${enterpriseCSS.palette.blue} !important`, // TODO
                    width: 'auto !important',
                    minWidth: 'auto !important',
                    marginRight: 4,
                    '& > span': {
                        fontSize: fontSize.small,
                    },
                },
                '&.secondary': {
                    color: enterpriseCSS.palette.button.darkGray || '#161616',
                    backgroundColor: palette.common?.white || '#fff',
                    border: `1px solid ${enterpriseCSS.palette.darkGray}` || '#161616', // TODO
                    '&:hover': {
                        backgroundColor: enterpriseCSS.palette.button.darkGray || '#161616',
                        color: enterpriseCSS.palette.white || '#fff', // TODO
                        border: `1px solid ${palette.cms?.secondary || '#161616'}`,
                    },
                },
                '&.tertiary': {
                    border: `1px solid ${palette.snipeTextPromo}`, // TODO
                    backgroundColor: palette.snipeTextPromo, // TODO
                    '&:hover': {
                        backgroundColor: palette.snipeTextPromo, // TODO
                    },
                },
            },
            '& .font-size-16': {
                fontSize: '16px',
            },
            '& .link-button': {
                cursor: 'pointer',
                position: 'relative',
                color: enterpriseCSS.palette.blue, // TODO
                '& .link-icon': {
                    fontSize: '16px',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                },
                '& .link-label': {
                    paddingLeft: '18px',
                    textTransform: 'none',
                },
            },
            '& .buttonForm': {
                paddingTop: rowSpacing * 2,
                paddingLeft: rowSpacing * 2,
                textAlign: 'center',
                'border-top': `1px solid ${palette.grey[300]}`,
                display: 'inline-block',
                width: '100%',
            },
            '& .loading-screen': {
                minHeight: rowSpacing * 40,
                position: 'relative',
            },
            '& .spinner': {
                top: '48%',
                left: '50%',
            },
            '& .error-inline': {
                color: enterpriseCSS.palette.error,
                background: 'none',
                display: 'block',
                padding: '4px 0 0 0',
                marginBottom: 0,
                borderRadius: 0,
            },
            '& .contentGrid': {
                border: `2px solid ${enterpriseCSS.palette.gray1}`,
                marginBottom: rowSpacing * 2,
                borderRadius: 2,
                '& .blockContent': {
                    margin: rowSpacing * 2,
                    '&.hasForm': {
                        margin: `${rowSpacing}px ${rowSpacing * 2}px`,
                    },
                },
            },
            '& .blockHeader': {
                backgroundColor: palette.grey7,
                color: enterpriseCSS.palette.gray1,
                textTransform: 'uppercase',
                padding: `${rowSpacing}px ${rowSpacing * 2}px`,
                fontWeight: 700,
            },
            '& .block': {
                borderRight: `1px solid ${palette.myAccount?.blockBorderRight || '#e2e2e2'}`,
            },
            '& .cursorPointer': {
                cursor: 'pointer',
            },
            '& .padding-left-right-5': {
                padding: '0 5px',
            },
            '& .padding-left-right-10': {
                padding: '0 10px',
            },
            '& .padding-top-4x': {
                paddingTop: `${rowSpacing * 4}px !important`,
            },
        },
        '& .billLeftSide': {
            width: '50%',
            float: 'left',
            '& form': {
                width: '80%',
                margin: '0 auto',
            },
            '& .card-title': {
                width: '80%',
                margin: '0 auto',
                display: 'block',
                fontSize: '16px', // TODO
                textTransform: 'uppercase',
                color: enterpriseCSS.palette.gray1,
                fontWeight: 700,
            },
            '& .required-text': {
                width: '80%',
                margin: '0 auto',
                display: 'block',
                fontSize: '12px', // TODO
                color: enterpriseCSS.palette.gray1,
                textAlign: 'right',
            },
            '& .default-card': {
                fontWeight: 'bold',
                marginTop: '20px', // TODO
                display: 'block',
            },
            '& .default-card-info': {
                color: enterpriseCSS.palette.gray1, // TODO
                fontSize: '12px', // TODO
            },
        },
        '& .billRigthtSide': {
            width: '50%',
            float: 'left',
        },
        '& .mainBillingCard': {
            marginTop: 22, // TODO
            position: 'relative',
            display: 'block',
            overflow: 'hidden',
            minHeight: '430px',
            '&.smallWidth': {
                '& .billLeftSide': {
                    width: '35% !important',
                },
                '& .billRigthtSide': {
                    width: '65% !important',
                },
                '&.no-card-info': {
                    '& .billRigthtSide': {
                        width: '635px !important',
                        float: 'none',
                        margin: '0 auto',
                    },
                },
            },
            '& .buttonForm': {
                position: 'absolute',
                bottom: 0,
                right: 0,
            },
            '& .checkbox-selecter': {
                paddingLeft: 0,
            },
        },
        '& .label-style': {
            fontSize: '12px', // TODO
            color: enterpriseCSS.palette.gray1, // TODO
            textAlign: 'left',
            padding: '10px 0px 5px',
        },
        '& .text-field-input': {
            padding: '10px 8px',
        },
        '& .recaptchaError': {
            color: 'red',
        },
        '& .borderErrorColor': {
            borderColor: 'red',
        },
        '& .desktop-field>div': {
            paddingRight: 0,
            '& fieldset': {
                borderRadius: 0,
            },

        },
        '& .desktop-adorment-start': {
            marginRight: 0,
            '& > p': {
                margin: 0,
                color: palette.common?.black || '#000',
            },
        },
        '& .desktop-adorment-end': {
            marginRight: 8,
        },
        '& .desktop-helper-text': {
            textAlign: ' left',
            margin: '4px 0px 0px',
            fontSize: `${fontSizeDesktop.small}px !important`,
            lineHeight: '1.2em',
        },
        '& .billing-heading': {
            color: enterpriseCSS.palette.gray1, // TO DO
            fontSize: '16px',
            fontWeight: '700',
            textTransform: 'uppercase',
        },
        '& .tableInfo': {
            '& th': {
                fontSize: 16, // TODO
                color: enterpriseCSS.palette.gray1, // TODO
                fontWeight: 'normal',
                textAlign: 'right',
                margin: '0',
                padding: '10px 0',
            },
            '& td': {
                padding: '10px',
                fontSize: '16px',
                '& .cardtype-name': {
                    position: 'relative',
                    display: 'inline-block',
                    paddingRight: '50px',
                    '& .cardtype-icon': {
                        position: 'absolute',
                        right: 0,
                        top: '-4px',
                    },
                },
            },
            '& .billingTitle': {
                '& th': {
                    fontSize: '16px !important',
                    textTransform: 'uppercase',
                    fontWeight: 700,
                    color: enterpriseCSS.palette.gray1, // TODO
                    paddingTop: 0,
                    whiteSpace: 'nowrap',
                },
                '& td': {
                    color: enterpriseCSS.palette.blue, // TODO
                    paddingTop: 0,
                    '& svg': {
                        fontSize: '16px',
                        verticalAlign: 'text-top',
                    },
                },
            },
        },
        '& .select-input': {
            border: '1px solid #c4c4c4',
        },
        '&.billInfo': {
            display: 'block',
            '& .billLeftSide': {
                width: '40%',
                '& .tableInfo': {
                    marginLeft: '24px',
                },
            },
            '& .billRigthtSide': {
                width: '58%',
                '& form': {
                    minHeight: '535px',
                },
                '& .cityField': {
                    marginRight: '15px',
                },
                '& .zipCode': {
                    marginLeft: '15px',
                },
            },
        },
        '& .address-verify': {
            padding: '0 24px',

            '& .buttons-wrapper': {
                position: 'absolute',
                bottom: 0,
                right: 0,
                display: 'block',
                width: '100%',
                textAlign: 'right',
            },
        },
        '& .buttonVerify': {
            color: palette.common?.white || '#fff',
            backgroundColor: palette.snipeTextPromo, // TODO
            marginRight: '15px',
            '&:hover': {
                backgroundColor: palette.snipeTextPromo, // TODO
            },
        },
        '& .focused': {
            border: '1px solid',
        },
    },
});
